var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1722608632715,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4269,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M571.134931 546.559428a59.134803 59.134803 0 1 1-118.269605 0V270.853011a59.134803 59.134803 0 1 1 118.269605 0z m-59.134803 255.994816a58.878808 58.878808 0 1 1 41.727155-17.151652 57.086844 57.086844 0 0 1-41.727155 17.151652zM512.000128 0.010496a501.74984 501.74984 0 0 0-199.419962 39.935191A509.685679 509.685679 0 0 0 39.945687 312.580166 501.74984 501.74984 0 0 0 0.010496 512.000128a501.74984 501.74984 0 0 0 39.935191 199.419962 509.685679 509.685679 0 0 0 272.634479 272.634479A501.74984 501.74984 0 0 0 512.000128 1023.98976a501.74984 501.74984 0 0 0 199.419962-39.935191 509.685679 509.685679 0 0 0 272.634479-272.634479A501.74984 501.74984 0 0 0 1023.98976 512.000128a501.74984 501.74984 0 0 0-39.935191-199.419962A509.685679 509.685679 0 0 0 711.42009 39.945687 501.74984 501.74984 0 0 0 512.000128 0.010496z",
    fill: "#1EA23B",
    "p-id": 4270
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.8d95f0244c2bedad6f7f8afd637f9140.svg";
export { ForwardRef as ReactComponent };